import type { PaginationResponse, PaginationSpec } from "@rpcbase/api"

import type { PaginationCursorCodecOptions } from "./cursor"
import { compileMongoPagination } from "./compileMongoPagination"
import { materializeMongoPagination } from "./materializePagination"
import { MongoAdapter } from "./mongoAdapter"


type MongoPaginateQueryLike<TNode> = {
  where: (delta: Record<string, unknown>) => unknown;
  sort: (sort: Record<string, 1 | -1>) => unknown;
  limit: (limit: number) => unknown;
  exec: () => Promise<TNode[]>;
}

export type PaginateMongoQueryOptions = {
  cursor: PaginationCursorCodecOptions;
  includeCursors?: boolean;
}

export const paginateMongoQuery = async <TNode>(
  query: MongoPaginateQueryLike<TNode>,
  pagination: PaginationSpec,
  options: PaginateMongoQueryOptions,
): Promise<PaginationResponse<TNode>> => {
  const compiled = compileMongoPagination(pagination, { cursor: options.cursor })

  MongoAdapter.applyPagination(query, compiled)

  const fetchedNodes = await query.exec()
  if (!Array.isArray(fetchedNodes)) {
    throw new Error("paginateMongoQuery expects query.exec() to return an array")
  }

  return materializeMongoPagination(compiled, fetchedNodes, {
    cursor: options.cursor,
    includeCursors: options.includeCursors,
  })
}
